module.exports = __webpack_public_path__ + "static/img/Logo8_TrailsOfIndochina_rev.c861c03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo8_TrailsOfIndochina_rev.png
// module id = 314
// module chunks = 2